<template>
  <div class="m-shifts">
    <b-modal
      id="shifts-modal"
      v-model="active"
      size="custom-size"
      centered
      hide-footer
      @shown="setTabs"
      @close="active = false"
    >
      <template #modal-title> Добавить сотрудников </template>

      <div v-show="!position" ref="tabs" class="tabs">
        <div class="tabs__wrapper">
          <div
            v-for="position in positions"
            :key="position.code"
            class="tab"
            :class="{
              active: activePosition === position,
            }"
            @click="activePosition = position"
          >
            {{ position.name }}
          </div>

          <div class="more" @click="onMoreClick">
            Еще...
            <div
              v-show="showTabs"
              class="tabs-list"
              :data-offset="moreOffset"
              :style="{
                'margin-right': -1 * moreOffset + 'px',
              }"
            >
              <shadow-scroll-container class="tabs-list__scroll">
                <div
                  v-for="position in positions"
                  :key="position.code"
                  class="tabs-list__item"
                  :class="{
                    active: activePosition === position,
                  }"
                  @click="onPositionClick(position)"
                >
                  {{ position.name }}
                </div>
              </shadow-scroll-container>
            </div>
          </div>
        </div>
      </div>

      <shadow-scroll-container class="scroll-container">
        <div class="actions">
          <c-switcher v-model="allFilials" label="Все филиалы" class="all-filials" />
          <c-input
            v-model="query"
            class="search"
            placeholder="Поиск по ФИО"
            type="text"
            :clearable="true"
            icon="search"
          />
        </div>
        <c-loader v-if="loading" class="loader" :active="true" :height="100"></c-loader>
        <div v-else-if="!workers.length" class="empty">Сотрудники не найдены</div>
        <div v-else-if="!filteredList.length" class="empty">Сотрудники не найдены</div>
        <div v-else class="list">
          <div
            v-for="worker in filteredList"
            :key="worker.data.id"
            :data-shift="worker.data.work_shift_type"
            class="list-item"
          >
            <c-switcher
              type="checkbox"
              :label="worker.data.name"
              :value="worker.checked"
              @input="toggleWorker(worker)"
            />
          </div>
        </div>
      </shadow-scroll-container>

      <div class="m-shifts-buttons">
        <c-button class="reset" size="large" label="Сбросить" @click="close" />

        <c-button class="apply" size="large" label="Применить" color="blue" @click="apply" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import CButton from "@/components/controls/button";
import CLoader from "@/components/loader";
import CSwitcher from "@/components/controls/switcher";
import CInput from "@/components/controls/input";
import ShadowScrollContainer from "@/components/shadow-scroll-container";

export default {
  components: {
    CButton,
    CSwitcher,
    CLoader,
    CInput,
    ShadowScrollContainer,
  },

  props: ["positions"],

  data() {
    return {
      active: false,

      position: null,
      activePosition: null,
      allFilials: false,
      query: "",
      workersList: {},

      filial: null,
      period: "",

      workers: [],
      loading: false,

      showTabs: false,
      moreOffset: 0,
    };
  },

  computed: {
    formattedQuery() {
      return this.query.trim().toLowerCase();
    },
    selectedWorkers() {
      return this.workers.filter((w) => w.checked).map((w) => w.data);
    },
    filteredList() {
      if (!this.formattedQuery) return this.workers;
      const query = this.formattedQuery;
      return this.workers.filter((w) => w.data.name.toLowerCase().includes(query));
    },
  },

  watch: {
    activePosition() {
      this.getWorkers();
      this.showTabs = false;
    },
    allFilials() {
      this.getWorkers();
    },
  },

  mounted() {
    this._cb = (e) => {
      const tabsContainer = this.$refs.tabs;
      if (!tabsContainer) return;
      const tabsList = tabsContainer.querySelector(".tabs-list");
      if (tabsList.contains(e.target)) return;

      const more = tabsContainer.querySelector(".more");
      if (more.contains(e.target)) return;
      this.showTabs = false;
    };

    this._resizeCb = () => {
      this.setTabs();
    };

    document.addEventListener("click", this._cb);
    window.addEventListener("resize", this._resizeCb);
  },

  beforeDestroy() {
    document.removeEventListener("click", this._cb);
    window.removeEventListener("resize", this._resizeCb);
  },

  methods: {
    resetTabs() {
      this.$nextTick(() => {
        const tabsContainer = this.$refs.tabs;
        if (!tabsContainer) return;

        const tabsList = tabsContainer.querySelector(".tabs-list");
        const tabs = tabsContainer.querySelectorAll(".tab");
        const listItems = tabsList.querySelectorAll(".tabs-list__item");
        const more = tabsContainer.querySelector(".more");

        // eslint-disable-next-line no-return-assign
        tabs.forEach((t) => (t.style.display = ""));
        // eslint-disable-next-line no-return-assign
        listItems.forEach((i) => (i.style.display = ""));
        more.style.display = "";

        this.showTabs = false;
      });
    },

    setTabs() {
      setTimeout(() => {
        const tabsContainer = this.$refs.tabs;
        if (!tabsContainer) return;

        const tabsWrapper = tabsContainer.querySelector(".tabs__wrapper");
        const tabsList = tabsContainer.querySelector(".tabs-list");
        const tabs = tabsContainer.querySelectorAll(".tab");
        const listItems = tabsList.querySelectorAll(".tabs-list__item");
        const more = tabsContainer.querySelector(".more");

        tabs.forEach((t) => {
          t.style.display = "none";
        });
        listItems.forEach((i) => {
          i.style.display = "none";
        });
        more.style.display = "none";

        const containerRect = tabsWrapper.getBoundingClientRect();

        const count = tabs.length;

        let i;

        for (i = 0; i < count; i++) {
          const tab = tabs[i];
          tab.style.display = "block";
          const rect = tab.getBoundingClientRect();

          const diff = containerRect.right - rect.right;

          if (diff < 0 || (i < count - 1 && diff < 60)) {
            tab.style.display = "none";
            break;
          }
        }

        if (i < count - 1) {
          more.style.display = "block";
          const position = more.getBoundingClientRect().right;
          this.moreOffset = position > 270 ? 0 : 270 - position;
        }

        for (let j = i; j < count; j++) {
          const tab = listItems[j];
          tab.style.display = "flex";
        }
      }, 400);
    },
    open(params) {
      // this.resetTabs();
      this.query = "";
      this.allFilials = false;
      this.filial = params.filial;
      this.period = params.period;
      this.position = params.position || null;

      if (this.position) this.activePosition = this.position;
      else {
        const [firstPosition] = this.positions;
        this.activePosition = firstPosition;
      }

      this.workersList = params.workersList;

      this.getWorkers();
      this.active = true;
    },

    onPositionClick(position) {
      this.activePosition = position;
      this.showTabs = false;
    },

    onMoreClick(event) {
      const menuItem = event.target.closest(".tabs-list__item");
      if (!menuItem) this.showTabs = true;
    },

    close() {
      this.active = false;
      this.$emit("close");
      this.showTabs = false;
      this.query = "";
    },

    getParams() {
      const params = {
        position: this.activePosition.code,
        period: this.period,
        filial: this.filial
      };
      if (this.allFilials) params.allFilials = 1;
      return params;
    },

    getWorkers() {
      this.loading = true;
      this.$store.dispatch("timesheets/getWorkersList", this.getParams()).then((items) => {
        const list = (this.workersList[this.activePosition.code] || []).map((w) => w.id);

        const workers = items.filter((i) => !list.includes(i.id));
        workers.sort((a, b) => (a.name > b.name ? 1 : -1));
        this.workers = workers.map((w) => ({
          data: w,
          checked: false,
        }));

        this.loading = false;
      });
    },

    toggleWorker(worker) {
      this.workers = this.workers.map((w) => {
        if (worker.data.id.toString() === w.data.id.toString()) {
          return {
            data: worker.data,
            checked: !w.checked,
          };
        }
        return w;
      });
    },

    apply() {
      this.$emit("apply", {
        position: this.activePosition,
        workers: this.selectedWorkers,
      });
      this.close();
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";
.tabs {
  margin-left: -30px;
  margin-right: -30px;
  margin-bottom: 16px;
  padding-bottom: 4px;
  z-index: 3;
  position: relative;

  &__wrapper {
    padding-left: 30px;
    padding-right: 30px;
  }

  &:after {
    display: block;
    content: "";
    height: 12px;
    background: linear-gradient(to top, #8e9cbb 0%, #ffffff 100%);
    opacity: 0.2;
  }

  &__wrapper {
    display: flex;
  }
  .tab {
    display: none;
    position: relative;
    font-size: 13px;
    line-height: 1;
    font-weight: 500;
    color: #0066ff;
    margin-right: 25px;
    cursor: pointer;
    white-space: nowrap;

    &.active {
      color: black;
      &:after {
        content: "";
        position: absolute;
        bottom: -16px;
        left: 0;
        right: 0;
        height: 4px;
        background: #ff238d;
      }
    }
  }
  .more {
    display: none;
    font-size: 13px;
    line-height: 1;
    font-weight: 500;
    color: #0066ff;
    cursor: pointer;
    position: relative;
  }
  .loader {
    z-index: 1;
  }
  &-list {
    position: absolute;
    width: 250px;
    top: 100%;
    margin-top: 10px;
    right: 0;
    background: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
    border-radius: 6px;
    z-index: 55;
    overflow: hidden;
    &__item {
      display: none;
      padding: 3px 15px;
      border-radius: 50px;
      cursor: pointer;
      display: flex;
      align-items: center;
      min-height: 26px;
      line-height: 1.2;
      color: black;
      font-weight: 400;
      font-size: 15px;

      &:hover,
      &.active {
        background: #e1edff;
      }
    }
    &__scroll {
      max-height: 300px;
      padding: 10px;
      max-width: 250px;
    }
  }
}
.scroll-container {
  height: 300px;
  position: relative;
  z-index: 1;
  padding-top: 16px;

  .actions {
    display: flex;
    margin-bottom: 24px;
  }

  .all-filials {
    margin-right: 30px;
    width: auto;
  }

  .search {
    flex-grow: 1;

    & /deep/ {
      .c-input-input::placeholder {
        font-style: italic;
      }
    }
  }

  .empty {
    font-size: 14px;
  }

  .list {
    &-item {
      margin-bottom: 20px;

      & /deep/ {
        .c-switcher-label {
          &:before {
            content: "";
            display: inline-block;
            width: 14px;
            height: 14px;
            margin-top: 1px;
            background-repeat: no-repeat;
            background-position: center;

            background-image: url("data:image/svg+xml,%3Csvg width='14' height='13' viewBox='0 0 14 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3 6.97644C3 8.63329 4.34315 9.97644 6 9.97644V11.9764M3 6.97644C3 5.31959 4.34315 3.97644 6 3.97644V1.97644M3 6.97644H1M2.46448 10.512L3.50003 9.47641M3.50003 4.47644L2.46449 3.4409M8.75195 5.23397C9.75131 4.09238 11.4296 3.88766 12.7035 4.67989C11.8052 5.23397 11.0269 6.03078 11.0268 7.21905C11.0268 8.40734 11.8052 9.20419 12.7035 9.75827C11.4296 10.5505 9.75131 10.3458 8.75195 9.20419C8.25409 8.63547 7.9855 8.05007 7.9855 7.21905C7.98551 6.38806 8.25409 5.80269 8.75195 5.23397Z' stroke='%23BFC9E0' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
            margin-right: 8px;
          }
        }
      }

      &[data-shift="night"] {
        & /deep/ {
          .c-switcher-label {
            &:before {
              content: "";
              display: inline-block;
              width: 14px;
              height: 14px;
              background-repeat: no-repeat;

              background-image: url("data:image/svg+xml,%3Csvg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.06362 1.97668C3.11572 2.43075 1.7264 4.20608 1.8605 6.22459C1.9273 7.23017 2.22598 8.03527 3.00944 8.81875C3.79293 9.60225 4.59808 9.90094 5.60365 9.96775C7.62217 10.1018 9.3975 8.71253 9.85156 6.76463C8.48233 7.08907 6.99716 7.07168 5.87685 5.95134C4.75655 4.83102 4.73917 3.34592 5.06362 1.97668Z' stroke='%23BFC9E0' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
              margin-right: 10px;
            }
          }
        }
      }

      &[data-shift="day"] {
        & /deep/ {
          .c-switcher-label {
            &:before {
              content: "";
              display: inline-block;
              width: 14px;
              height: 14px;
              background-repeat: no-repeat;

              background-image: url("data:image/svg+xml,%3Csvg width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.85156 6.5C9.85156 8.15685 8.50842 9.5 6.85156 9.5M9.85156 6.5C9.85156 4.84315 8.50842 3.5 6.85156 3.5M9.85156 6.5H11.8516M6.85156 9.5C5.19471 9.5 3.85156 8.15685 3.85156 6.5M6.85156 9.5V11.5M3.85156 6.5C3.85156 4.84315 5.19471 3.5 6.85156 3.5M3.85156 6.5H1.85156M6.85156 3.5V1.5M9.35156 4L10.3871 2.96445M3.31604 10.0355L4.35159 8.99997M4.35159 4L3.31605 2.96445M10.3871 10.0355L9.35156 8.99997' stroke='%23BFC9E0' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E%0A");
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
.m-shifts-buttons {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;

  .reset {
    margin-right: 10px;
  }
}
@include onlyMobile {
  /deep/ {
    .modal-title {
      font-size: 18px;
      font-weight: 500;
    }
  }
  .scroll-container {
    flex-grow: 1;
    height: auto;
    overflow: hidden;
  }

  .actions {
    flex-direction: column;

    .all-filials {
      margin-bottom: 25px;
    }
  }

  .m-shifts-buttons {
    margin-left: -21px;
    margin-right: -21px;
    margin-top: 0;

    background: #ffffff;
    box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);

    .reset,
    .apply {
      width: 50%;
      margin: 0;

      & /deep/ {
        .c-button__wrapper {
          width: 100%;
          border-radius: 0;
          justify-content: center;
        }
      }
    }
  }

  & /deep/ {
    .modal-body {
      padding-bottom: 0;
    }
  }
}
</style>
